import React from 'react';
import { Mail } from 'lucide-react';

// Coded "one email, three records" extraction graphic (crisp at any size).
// Copy fixed: no em/en dashes (hyphens/middots only).

const LOGO = 'https://customer-assets.emergentagent.com/job_archen-studio/artifacts/kz0rmfk8_logo.svg';

const ROWS = [
  { cat: 'Approval', title: 'Arabescato Marble', sub: 'Client approved \u00B7 May 14', initials: 'JR', avatar: '#DCE3EC', ink: '#4B5A6B' },
  { cat: 'Scope change', title: 'Add outlet to kitchen island', sub: '+$1,250 \u00B7 May 14', initials: 'TA', avatar: '#DDE7DA', ink: '#4E6B3F' },
  { cat: 'Commitment', title: 'Visual Comfort lighting', sub: 'Lead time: 8-10 weeks \u00B7 May 14', initials: 'MK', avatar: '#EADFCF', ink: '#6B5B45' },
];

const ExtractionFlow = () => (
  <div className="w-full flex flex-col lg:flex-row items-stretch gap-6 lg:gap-3">
    {/* One email */}
    <div className="w-full lg:w-[300px] shrink-0 flex lg:self-center">
      <div className="flex flex-col w-full rounded-2xl border border-[#E8DFD1] bg-gradient-to-b from-[#FDFAF5] to-[#F7F0E6] overflow-hidden">
        <div className="flex items-center gap-2 px-5 py-3.5 border-b border-[#EAE1D3] text-[#3A2F26] text-[13.5px] font-medium">
          <Mail size={15} className="text-[#8B7355]" strokeWidth={1.8} /> One email
        </div>
        <div className="px-5 py-4">
          <div className="flex items-center gap-2">
            <span className="w-7 h-7 rounded-full bg-[#DCE3EC] text-[#4B5A6B] text-[10.5px] font-semibold flex items-center justify-center">JR</span>
            <span className="text-[#2D2520] text-[13.5px] font-medium">Julia R.</span>
            <span className="ml-auto text-[#A89888] text-[12px]">May 14</span>
          </div>
          <p className="mt-3 text-[#4A3F34] text-[14px] leading-relaxed">
            Yes, Arabescato is approved. Also, let's add the outlet to the island. John confirmed the lighting is 8-10 weeks.
          </p>
        </div>
      </div>
    </div>

    {/* Connector */}
    <div className="hidden lg:flex items-center w-7 shrink-0" aria-hidden="true">
      <svg viewBox="0 0 40 200" className="w-full h-44" preserveAspectRatio="none">
        {[52, 100, 148].map((y) => (
          <path key={y} d={`M0,100 C18,100 22,${y} 40,${y}`} fill="none" stroke="#C6B79E" strokeWidth="1" strokeDasharray="2 3" strokeLinecap="round" />
        ))}
      </svg>
    </div>

    {/* Project Memory */}
    <div className="w-full lg:flex-1 flex">
      <div className="flex flex-col w-full rounded-2xl border border-[#E8DFD1] bg-gradient-to-b from-[#FDFAF5] to-[#F7F0E6] overflow-hidden">
        <div className="flex items-center gap-3 px-6 py-4 border-b border-[#EAE1D3]">
          <img src={LOGO} alt="" className="w-5 h-5" />
          <span className="text-[#1F1812] text-[17px]" style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 500 }}>Project Memory</span>
          <span className="text-[#A89888] text-[13px]">Park Ave Residence</span>
          <span className="ml-auto inline-flex items-center gap-1.5 bg-[#E7EEE0] text-[#5B7247] text-[11.5px] rounded-full px-2.5 py-1 whitespace-nowrap">
            <span className="w-1.5 h-1.5 rounded-full bg-[#6E8B4F]" /> 3 items extracted
          </span>
        </div>
        <div className="px-6">
          {ROWS.map((r, i) => (
            <div key={r.title} className={`flex items-center gap-4 py-4 ${i > 0 ? 'border-t border-[#EEE6D9]' : ''}`}>
              <div className="flex-1 min-w-0">
                <p className="text-[#9C8A73] text-[10.5px] tracking-[0.14em] uppercase">{r.cat}</p>
                <p className="mt-1 text-[#1F1812] text-[16px] font-semibold truncate">{r.title}</p>
                <p className="mt-0.5 text-[#7A6B58] text-[13px]">{r.sub}</p>
              </div>
              <span className="w-7 h-7 rounded-full text-[10.5px] font-semibold flex items-center justify-center shrink-0" style={{ backgroundColor: r.avatar, color: r.ink }}>{r.initials}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);

export default ExtractionFlow;
